import React from 'react';
import PropTypes from 'prop-types';

const PaymentItem = (props) => {
  return (
    <div
      className="col-md-6"
      >
      <div
        onClick={() => props.onClick(props.item)}
        className={(props.active ? 'payment-active' : '')}
        style={{
          cursor: 'pointer',
          border: '1px solid #bbbaba', 
          marginTop: 6,
          marginBottom: 6,
          padding: 10,
        }}
      >
        <strong>{props.title}</strong>
      <br />
      <br />
        {props.subtitle}
      </div>
    </div>
  );
};

PaymentItem.defaultProps = {
  active: false,
  subtitle: '-',
  title: '-',
  start: '-',
  info: '-',
  onClick: () => {}
};

PaymentItem.propTypes = {
  subtitle: PropTypes.string,
  active: PropTypes.bool,
  title: PropTypes.string,
  start: PropTypes.string,
  info: PropTypes.string,
  onClick: PropTypes.func
};

export default PaymentItem;
